import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Input from '@mui/material/Input';
import { createCv } from './services';
import { Alert ,Card ,Grid , InputLabel, TextField, Typography} from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import { getCvsAction } from "./actions";
import CandidateService from '../../services/candidateService';
import CustomSelect from './CustomInput';
import { Select } from 'semantic-ui-react';

const UploadCv = ({ open, onClose, onUpload }) => {
  const [file, setFile] = useState(null);
  const [nic, setNic] = useState('');
  const [name, setName] = useState('');
  const [occupation, setOccupation] = useState([]);
  const [passportNo, setPassportNo] = useState('');
  const [sector, setSector] = useState('');
  const [options, setOptions] = useState({});
  const [gcc, setGcc] = useState('');
  const [gccYears, setGccYears] = useState('');
  const [experienceYears, setExperienceYears] = useState('');
  const [age, setAge] = useState('');

  const fetchOptions = async () => {
    try {
      const response = await CandidateService.getAllOptions();
      const data = response.data;
  
      const groupedOptions = {};
      data.forEach(option => {
        const { fieldName, label, value } = option;
        if (groupedOptions.hasOwnProperty(fieldName)) {
          groupedOptions[fieldName].push({ label, value });
        } else {
          groupedOptions[fieldName] = [{ label, value }];
        }
      });
  
      setOptions(prevOptions => ({
        ...prevOptions,
        ...groupedOptions
      }));
    } catch (error) {
      console.error('Error fetching options:', error);
    }
  };

  React.useEffect(() => {
    fetchOptions();
  }, []);

  const dispatch = useDispatch();

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);
  };


  const calculateAgeFromNIC = (nic) => {
    // Extract the birth year (YY) from the NIC
    let birthYear = parseInt(nic.substr(0, 2), 10);
    
    // Check if the birth year is less than 100 (prior to 2000) or 100 or greater (from 2000 onwards)
    let fullBirthYear = birthYear < 100 ? 1900 + birthYear : 2000 + birthYear;
    
    // Get the current year
    const currentYear = new Date().getFullYear();
    
    // Calculate the age
    let age = currentYear - fullBirthYear;

    if (age>100){
      birthYear = parseInt(nic.substr(0, 4), 10);
      fullBirthYear = birthYear;
      age = currentYear - fullBirthYear;
    }
    
    return age;
  };


  const handleNicChange = (event) => {
    const value = event.target.value.toUpperCase();
    setNic(value);
    setAge(calculateAgeFromNIC(value));
  };

  const handlePassportNoChange = (event) => {
    const value = event.target.value.toUpperCase();
    setPassportNo(value);
  };
  

  const handleNameChange = (event) => {
    const value = event.target.value;
    setName(value);
  };
  
  const handleOccupationChange = (event) => {
    const selectedOccupations = event.target.value.split(",").map((occupation) => occupation.trim());
    setOccupation(selectedOccupations);
  };
  
  const [loading, setLoading] = useState(false);
  const handleUpload = () => {
    setLoading(true);
   // Create an array to hold the occupations
    const occupations = [occupation, occupation1, occupation2];

    // Filter out the empty or null occupations and join the remaining ones with a comma
    const occupationCombined = occupations.filter(Boolean).join(',');

    const formData = new FormData();
    formData.append('file', file);
    formData.append('nic', nic);
    formData.append('sector', sector);
    formData.append('passportNo', passportNo);
    formData.append('extraField', JSON.stringify({
      'name': name,
      'occupation': occupation,
      'occupation1': occupation1,
      'occupation2': occupation2,
      'sector': sector,
      'experienceYears': experienceYears,
      'gcc': gcc,
      'age': age
    }));

    createCv(formData).then((response) => {
      alert("CV Uploaded Successfully");
      console.log(response);
      setNic('');
      setPassportNo('');
      setSector('');
      setLoading(false);
      setName('');
      setOccupation('');
      setOccupation1('');
      setOccupation2('');
      setExperienceYears('');
      setGcc('');
      setFile(null);
      dispatch(getCvsAction());
      onClose();
    }).catch((error) => {
      alert("Duplicate CV!");
      console.log(error);
      setFile(null);
      setLoading(false);
      setNic('');
      setSector('');
      setPassportNo('');
      setName('');
      setOccupation('');
      setExperienceYears('');
      setGcc('');
      setOccupation1('');
      setOccupation2('');
      
      onClose();
    });

    
  };

  const handleChange = (e, fieldName) => {
    const value = e.target.value;
    console.log(value);
  }

  const [occupation1, setOccupation1] = useState([]);

  const handleOccupation1Change = (event) => {  
    const selectedOccupations = event.target.value.split(",").map((occupation) => occupation.trim());
    console.log(selectedOccupations)
    setOccupation1(selectedOccupations);
  };

  const [occupation2, setOccupation2] = useState([]);

  const handleOccupation2Change = (event) => {
    const selectedOccupations = event.target.value.split(",").map((occupation) => occupation.trim());
    console.log(selectedOccupations)
    setOccupation2(selectedOccupations);
  };

  const [validated, setValidated] = useState(false);
  const [message, setMessage] = useState('');

  React.useEffect(() => {

    if(name.length < 5){
      setValidated(false);
      setMessage('Name should be at least 5 characters long');
      return;
    }
    else if(nic.length < 2){
      setValidated(false);
      setMessage('Please enter a valid NIC');
      return;
    }
    else if(nic.length < 5){
      setValidated(true);
      setMessage('Please verify NIC before uploading');
      return;
    }

    //remove spaces fro nic
    const nicWithoutSpaces = nic.replace(/\s/g, '');
    setNic(nicWithoutSpaces);

    //only allow numbers and letters remove any other characters
    const nicWithoutSpecialCharacters = nicWithoutSpaces.replace(/[^a-zA-Z0-9]/g, '');
    setNic(nicWithoutSpecialCharacters);

    setValidated(true);

  }, [name, nic]);

return (
<>
<Card style={{
    padding:10
}}>
    <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
    <div style={{ marginBottom: '16px',marginTop:'4px' }}>
      <TextField
        label="Name"
        fullWidth
        value={name}
        size='small'
        onChange={handleNameChange}
      />
    </div>
    <div style={{ marginBottom: '16px' }}>
      <TextField
        label="NIC"
        fullWidth
        size='small'
        value={nic}
        onChange={handleNicChange}
      />
    </div>
    <div style={{ marginBottom: '16px' }}>
      <TextField
        label="Passport No."
        fullWidth
        size='small'
        value={passportNo}
        onChange={handlePassportNoChange}
      />
    </div>
    <div style={{ marginBottom: '16px' }}>


      <CustomSelect
        options={options.designations}
                name="occupation"
                fetchOptions={fetchOptions}
                value={occupation}
                onChange={(e) =>setOccupation(e.target.value)}
                fieldName="designations"
      />
      </div>
      <div style={{ marginBottom: '16px' }}>
          <CustomSelect
                    options={options.designations}
                    name="occupation2"
                    fetchOptions={fetchOptions}
                    value={occupation2}
                    onChange={(e) =>handleOccupation2Change(e)}
                    fieldName="designations"
                  />
      </div>
    </Grid>
    <Grid item xs={12} sm={6}>

    <div style={{ marginBottom: '16px' }}>
      <TextField
        label="Age."
        fullWidth
        size='small'
        value={age}
        onChange={(e) => setAge(e.target.value)}
      />
    </div>
    <div style={{ marginBottom: '16px' }}>
      <TextField
        label="Experience Years"
        fullWidth
        size='small'
        value={experienceYears}
        onChange={(e) => setExperienceYears(e.target.value)}
      />
    </div>
    <div style={{ marginBottom: '16px' }}>
      <TextField
        label="Gcc Experience Years"
        fullWidth
        size='small'
        value={gcc}
        onChange={(e) => setGcc(e.target.value)}
      />      
    </div>
    <div style={{ marginBottom: '16px' }}>
    <CustomSelect
              options={options.designations}
              name="occupation1"
              fetchOptions={fetchOptions}
              value={occupation1}
              onChange={(e) =>handleOccupation1Change(e)}
              fieldName="designations"
            />
    </div>
    <div style={{ marginBottom: '16px' }}>
    <CustomSelect
              options={options.sectors}
              name="Sector"
              fetchOptions={fetchOptions}
              value={sector}
              onChange={(e) =>setSector(e.target.value)}
              fieldName="sectors"
            />
    </div>
    </Grid>
    </Grid>
    <div style={{ marginBottom: '16px' }}>
      <InputLabel htmlFor="upload-file">CV File</InputLabel>
      <Input
        id="upload-file"
        type="file"
        onChange={handleFileChange}
        fullWidth
      />
    </div>
  
  <Typography variant="body2" color="red" style={{
    padding:10
  }}>
    {message}
  </Typography>
  <Button onClick={handleUpload} disabled={!file || !nic || !name || !validated}>
      {
        loading ? 'Uploading...' : 'Upload'
      }
    </Button>
  </Card>
    </>
  
  );
};

export default UploadCv;
